/******************************************************************
 * CoreAssets
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class CoreAssets {

    static readonly BACKGROUND = require("/src/assets/background/background.png");
    static readonly WOMAN = require("/src/assets/illustration/woman.png");
    static readonly FOOD_HOTSPOT = require("/src/assets/illustration/food-hotspot.svg");
    static readonly HEALTH_HOTSPOT = require("/src/assets/illustration/health-hotspot.svg");
    static readonly HOUSE_HOTSPOT = require("/src/assets/illustration/house-hotspot.svg");
    static readonly ELECTRONIC_HOTSPOT = require("/src/assets/illustration/electronic-hotspot.svg");
    static readonly MOBILITY_HOTSPOT = require("/src/assets/illustration/mobility-hotspot.svg");
    static readonly RECYCLING_HOTSPOT = require("/src/assets/illustration/recycling-hotspot.svg");
    static readonly CLOUD_HOTSPOT = require("/src/assets/illustration/cloud-hotspot.svg");
    static readonly CLOTHING_HOTSPOT = require("/src/assets/illustration/clothing-hotspot.svg");

    static readonly DESC_ARROW = require("/src/assets/icons/arrow.svg");
    static readonly CLOSE_ICON = require("/src/assets/icons/close-icon.svg");

}
